// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var RegExUtils$SmartcutsMacros = require("../../bs-utils/src/RegExUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var GoogleSheetTypes$SmartcutsMacros = require("./GoogleSheetTypes.bs.js");
var CopyImageSrcCommand$SmartcutsMacros = require("./commands/CopyImageSrcCommand.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var Selection__StrictSelection$SmartcutsMacros = require("./Selection/Selection__StrictSelection.bs.js");

function findCommandIndexWithMatchingUrl(url, log) {
  return ListUtils$SmartcutsMacros.findIndex((function (param) {
                return param.contextGlobal.url === url;
              }), log);
}

function maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef, value) {
  if (typeof value === "number") {
    return value;
  }
  if (value.TAG !== /* Value */1) {
    return value;
  }
  var newDataRef = Curry._2(maybeSubstituteUrlIntoDataRef, log, value._0);
  if (newDataRef !== undefined) {
    return {
            TAG: /* Value */1,
            _0: newDataRef
          };
  } else {
    return value;
  }
}

function maybeSubstituteUrlIntoDataRef(log, dataRef) {
  var maybeUrl;
  var exit = 0;
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        exit = 1;
        break;
    default:
      maybeUrl = undefined;
  }
  if (exit === 1) {
    var str = dataRef._0;
    maybeUrl = RegExUtils$SmartcutsMacros.isUrl(str) ? str : undefined;
  }
  return OptionUtils$SmartcutsMacros.andThen((function (url) {
                var matchingCommandIndex = findCommandIndexWithMatchingUrl(url, log);
                if (matchingCommandIndex !== undefined) {
                  return {
                          TAG: /* TextFromUrl */5,
                          _0: {
                            commandId: matchingCommandIndex,
                            commandIndex: matchingCommandIndex,
                            url: url
                          }
                        };
                }
                
              }), maybeUrl);
}

function maybeSubstituteUrlIntoAuthoringCommandWithContext(log, commandWithContext) {
  var command = commandWithContext.command;
  if (typeof command === "number") {
    return commandWithContext;
  }
  switch (command.TAG | 0) {
    case /* PasteInInputCommand */27 :
        var commandValue = command._0;
        var dataRef = commandValue.text;
        var newDataRef = maybeSubstituteUrlIntoDataRef(log, dataRef);
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* PasteInInputCommand */27,
                  _0: {
                    positioning: commandValue.positioning,
                    text: newDataRef !== undefined ? newDataRef : dataRef,
                    label: commandValue.label
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    case /* PasteInContentEditableCommand */28 :
        var commandValue$1 = command._0;
        var dataRef$1 = commandValue$1.text;
        var newDataRef$1 = maybeSubstituteUrlIntoDataRef(log, dataRef$1);
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* PasteInContentEditableCommand */28,
                  _0: {
                    positioning: commandValue$1.positioning,
                    text: newDataRef$1 !== undefined ? newDataRef$1 : dataRef$1
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    case /* GoogleSheetsCommand */33 :
        var commandValue$2 = command._0;
        var upsertRowParam = commandValue$2.update;
        if (upsertRowParam.TAG === /* UpsertRow */0) {
          var match = upsertRowParam._0;
          var rowLocation = match.rowLocation;
          return {
                  id: commandWithContext.id,
                  command: {
                    TAG: /* GoogleSheetsCommand */33,
                    _0: {
                      spreadsheetId: commandValue$2.spreadsheetId,
                      sheetName: commandValue$2.sheetName,
                      colNames: commandValue$2.colNames,
                      update: {
                        TAG: /* UpsertRow */0,
                        _0: {
                          rowLocation: {
                            rowIndex: rowLocation.rowIndex,
                            keyColumnIndex: rowLocation.keyColumnIndex,
                            rowData: $$Array.map((function (param) {
                                    return maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef, param);
                                  }), rowLocation.rowData)
                          },
                          cellValues: Belt_Array.map(match.cellValues, (function (cellValue) {
                                  if (typeof cellValue === "number") {
                                    return cellValue;
                                  }
                                  if (cellValue.TAG !== /* Value */1) {
                                    return cellValue;
                                  }
                                  var dataRef = cellValue._0;
                                  var newDataRef = maybeSubstituteUrlIntoDataRef(log, dataRef);
                                  return {
                                          TAG: /* Value */1,
                                          _0: newDataRef !== undefined ? newDataRef : dataRef
                                        };
                                }))
                        }
                      }
                    }
                  },
                  contextGlobal: commandWithContext.contextGlobal
                };
        }
        var upsertRowParam$1 = upsertRowParam._0;
        var cellUpdate = upsertRowParam$1.cellUpdate;
        var rowLocation$1 = upsertRowParam$1.rowLocation;
        var dataRef$2 = cellUpdate.toValue;
        var tmp;
        if (typeof dataRef$2 === "number" || dataRef$2.TAG !== /* Value */1) {
          tmp = cellUpdate;
        } else {
          var dataRef$3 = dataRef$2._0;
          var newDataRef$2 = maybeSubstituteUrlIntoDataRef(log, dataRef$3);
          tmp = {
            fromValue: cellUpdate.fromValue,
            toValue: {
              TAG: /* Value */1,
              _0: newDataRef$2 !== undefined ? newDataRef$2 : dataRef$3
            }
          };
        }
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* GoogleSheetsCommand */33,
                  _0: {
                    spreadsheetId: commandValue$2.spreadsheetId,
                    sheetName: commandValue$2.sheetName,
                    colNames: commandValue$2.colNames,
                    update: {
                      TAG: /* UpdateCell */1,
                      _0: {
                        rowLocation: {
                          rowIndex: rowLocation$1.rowIndex,
                          keyColumnIndex: rowLocation$1.keyColumnIndex,
                          rowData: $$Array.map((function (param) {
                                  return maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef, param);
                                }), rowLocation$1.rowData)
                        },
                        updatedColIndex: upsertRowParam$1.updatedColIndex,
                        cellUpdate: tmp
                      }
                    }
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    default:
      return commandWithContext;
  }
}

function lookupMaybePriorMatchingImgSrcFromContextMenuCommand(commandLog, commandLogIndex, text) {
  var imageUrl = URLUtils$SmartcutsMacros.$$URL.fromString(text);
  if (imageUrl === undefined) {
    return ;
  }
  var arg = Belt_Array.slice($$Array.of_list(commandLog), 0, commandLogIndex);
  var param = function (param$1, i) {
    var tabUrl = param$1.contextGlobal.url;
    var command = param$1.command;
    if (typeof command === "number") {
      return ;
    }
    if (command.TAG !== /* ContextMenuCommand */34) {
      return ;
    }
    var match = command._0;
    var maybeSubPathToImg = match.maybeSubPathToImg;
    var selector = match.selector;
    var match$1 = Selector$SmartcutsMacros.maybeGetLeafNode(selector);
    if (match$1 === undefined) {
      return ;
    }
    var match$2 = match$1.tagName;
    if (match$2 !== undefined && match$2 === "img" && Belt_Array.some(match$1.attributes, (function (param) {
              if (param[0] === "src") {
                return CopyImageSrcCommand$SmartcutsMacros.isImgSrcEqualToImageUrl(param[1], imageUrl, tabUrl);
              } else {
                return false;
              }
            }))) {
      return [
              i,
              {
                selector: selector,
                src: text
              }
            ];
    }
    if (maybeSubPathToImg === undefined) {
      return ;
    }
    var nestedImgSrc = maybeSubPathToImg[1];
    if (nestedImgSrc !== undefined && CopyImageSrcCommand$SmartcutsMacros.isImgSrcEqualToImageUrl(nestedImgSrc, imageUrl, tabUrl)) {
      return [
              i,
              {
                selector: List.append(selector, maybeSubPathToImg[0]),
                src: text
              }
            ];
    }
    
  };
  return ArrayUtils$SmartcutsMacros.shortcutWithIndex(param, arg);
}

function maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text, commandWithContext, buildNewCommandWithTextFromCommandDataRef) {
  return Belt_Option.map(lookupMaybePriorMatchingImgSrcFromContextMenuCommand(commandLog, commandLogIndex, text), (function (param) {
                var indexToUpdate = param[0];
                return [
                        {
                          id: commandWithContext.id,
                          command: Curry._1(buildNewCommandWithTextFromCommandDataRef, {
                                TAG: /* TextFromCommand */2,
                                _0: {
                                  commandId: Belt_List.getExn(commandLog, indexToUpdate).id,
                                  commandInfo: null,
                                  text: text
                                }
                              }),
                          contextGlobal: commandWithContext.contextGlobal
                        },
                        [
                          indexToUpdate,
                          param[1]
                        ]
                      ];
              }));
}

function maybeConvertContextMenuCmdsToCopyImageSrcCmds(commandLog, commandLogIndex, commandWithContext) {
  var command = commandWithContext.command;
  if (typeof command === "number") {
    return ;
  }
  switch (command.TAG | 0) {
    case /* PasteInInputCommand */27 :
        var cmdVal = command._0;
        var text = cmdVal.text;
        switch (text.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              break;
          default:
            return ;
        }
        var text$1 = text._0;
        if (text$1.startsWith("http")) {
          return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text$1, commandWithContext, (function (textFromCommandDataRef) {
                        return {
                                TAG: /* PasteInInputCommand */27,
                                _0: {
                                  positioning: cmdVal.positioning,
                                  text: textFromCommandDataRef,
                                  label: cmdVal.label
                                }
                              };
                      }));
        } else {
          return ;
        }
    case /* PasteInContentEditableCommand */28 :
        var cmdVal$1 = command._0;
        var text$2 = cmdVal$1.text;
        switch (text$2.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              break;
          default:
            return ;
        }
        var text$3 = text$2._0;
        if (text$3.startsWith("http")) {
          return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text$3, commandWithContext, (function (textFromCommandDataRef) {
                        return {
                                TAG: /* PasteInContentEditableCommand */28,
                                _0: {
                                  positioning: cmdVal$1.positioning,
                                  text: textFromCommandDataRef
                                }
                              };
                      }));
        } else {
          return ;
        }
    case /* GoogleSheetsCommand */33 :
        var cmdVal$2 = command._0;
        var update = cmdVal$2.update;
        if (update.TAG === /* UpsertRow */0) {
          var upsertRow = update._0;
          var cellValues = upsertRow.cellValues;
          var maybeReferencedUrlAndIndex = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (cellValue, i) {
                  if (typeof cellValue === "number") {
                    return ;
                  }
                  if (cellValue.TAG !== /* Value */1) {
                    return ;
                  }
                  var text = cellValue._0;
                  switch (text.TAG | 0) {
                    case /* StaticText */0 :
                    case /* PasteText */1 :
                        break;
                    default:
                      return ;
                  }
                  var text$1 = text._0;
                  if (text$1.startsWith("http")) {
                    return [
                            text$1,
                            i
                          ];
                  }
                  
                }), cellValues);
          return Belt_Option.flatMap(maybeReferencedUrlAndIndex, (function (param) {
                        var index = param[1];
                        return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, param[0], commandWithContext, (function (textFromCommandDataRef) {
                                      return {
                                              TAG: /* GoogleSheetsCommand */33,
                                              _0: {
                                                spreadsheetId: cmdVal$2.spreadsheetId,
                                                sheetName: cmdVal$2.sheetName,
                                                colNames: cmdVal$2.colNames,
                                                update: {
                                                  TAG: /* UpsertRow */0,
                                                  _0: {
                                                    rowLocation: upsertRow.rowLocation,
                                                    cellValues: ArrayUtils$SmartcutsMacros.setWithoutFill2(cellValues, index, {
                                                          TAG: /* Value */1,
                                                          _0: textFromCommandDataRef
                                                        })
                                                  }
                                                }
                                              }
                                            };
                                    }));
                      }));
        }
        var updateCell = update._0;
        var cellUpdate = updateCell.cellUpdate;
        var match = cellUpdate.toValue;
        if (typeof match === "number") {
          return ;
        }
        if (match.TAG !== /* Value */1) {
          return ;
        }
        var text$4 = match._0;
        switch (text$4.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              break;
          default:
            return ;
        }
        var text$5 = text$4._0;
        if (text$5.startsWith("http")) {
          return maybeUpdateCommandReferencingImageAddress(commandLog, commandLogIndex, text$5, commandWithContext, (function (textFromCommandDataRef) {
                        return {
                                TAG: /* GoogleSheetsCommand */33,
                                _0: {
                                  spreadsheetId: cmdVal$2.spreadsheetId,
                                  sheetName: cmdVal$2.sheetName,
                                  colNames: cmdVal$2.colNames,
                                  update: {
                                    TAG: /* UpdateCell */1,
                                    _0: {
                                      rowLocation: updateCell.rowLocation,
                                      updatedColIndex: updateCell.updatedColIndex,
                                      cellUpdate: {
                                        fromValue: cellUpdate.fromValue,
                                        toValue: {
                                          TAG: /* Value */1,
                                          _0: textFromCommandDataRef
                                        }
                                      }
                                    }
                                  }
                                }
                              };
                      }));
        } else {
          return ;
        }
        break;
    default:
      return ;
  }
}

function adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell(commandLog, spreadsheetId, sheetName, commandLogIndex, rowLocation) {
  var priorCommandsWithContext = Belt_Array.slice($$Array.of_list(commandLog), 0, commandLogIndex);
  var maybeIndexOfMatchingCommand = Belt_Option.map(Belt_Array.getIndexBy(Belt_Array.reverse(priorCommandsWithContext), (function (param) {
              var command = param.command;
              if (typeof command === "number") {
                return false;
              }
              if (command.TAG !== /* GoogleSheetsCommand */33) {
                return false;
              }
              var curr = command._0;
              var upsert = curr.update;
              if (upsert.TAG === /* UpsertRow */0 && curr.spreadsheetId === spreadsheetId && curr.sheetName === sheetName) {
                return Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.RowLocation.getPrimaryKeyText, upsert._0.rowLocation) === Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.RowLocation.getPrimaryKeyText, rowLocation);
              } else {
                return false;
              }
            })), (function (reversedIndex) {
          return (commandLogIndex - 1 | 0) - reversedIndex | 0;
        }));
  var maybeCommandId = OptionUtils$SmartcutsMacros.andThen((function (index) {
          var match = Belt_List.get(commandLog, index);
          if (match !== undefined) {
            return match.id;
          }
          
        }), maybeIndexOfMatchingCommand);
  var arg = Belt_Option.map(maybeCommandId, (function (commandId) {
          return {
                  rowIndex: rowLocation.rowIndex,
                  keyColumnIndex: rowLocation.keyColumnIndex,
                  rowData: ArrayUtils$SmartcutsMacros.setWithoutFill(rowLocation.keyColumnIndex, {
                        TAG: /* Value */1,
                        _0: {
                          TAG: /* TextFromGSheetUpsertCommand */3,
                          _0: {
                            commandId: commandId,
                            text: Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.RowLocation.getPrimaryKeyText, rowLocation)
                          }
                        }
                      }, rowLocation.rowData)
                };
        }));
  return OptionUtils$SmartcutsMacros.withDefault(rowLocation, arg);
}

function adjustGoogleSheetCommandPrimaryLookups(commandLog, commandLogIndex, commandWithContext) {
  var command = commandWithContext.command;
  if (typeof command === "number") {
    return commandWithContext;
  }
  if (command.TAG !== /* GoogleSheetsCommand */33) {
    return commandWithContext;
  }
  var cmdVal = command._0;
  var update = cmdVal.update;
  var tmp;
  if (update.TAG === /* UpsertRow */0) {
    tmp = update;
  } else {
    var updateCell = update._0;
    tmp = {
      TAG: /* UpdateCell */1,
      _0: {
        rowLocation: adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell(commandLog, cmdVal.spreadsheetId, cmdVal.sheetName, commandLogIndex, updateCell.rowLocation),
        updatedColIndex: updateCell.updatedColIndex,
        cellUpdate: updateCell.cellUpdate
      }
    };
  }
  return {
          id: commandWithContext.id,
          command: {
            TAG: /* GoogleSheetsCommand */33,
            _0: {
              spreadsheetId: cmdVal.spreadsheetId,
              sheetName: cmdVal.sheetName,
              colNames: cmdVal.colNames,
              update: tmp
            }
          },
          contextGlobal: commandWithContext.contextGlobal
        };
}

function getCommandLogIdOfLastCopyOrCutCommand(text, commandLog) {
  var maybeIndexOfMatchingCommand = OptionUtils$SmartcutsMacros.map(Belt_Array.getIndexBy(Belt_Array.reverse($$Array.of_list(commandLog)), (function (param) {
              var tmp = param.command;
              if (typeof tmp === "number") {
                return false;
              }
              switch (tmp.TAG | 0) {
                case /* CopyCommand */24 :
                case /* CopyLinkAddressCommand */25 :
                case /* CutCommand */26 :
                    return true;
                default:
                  return false;
              }
            })), (function (reversedIndex) {
          return (List.length(commandLog) - 1 | 0) - reversedIndex | 0;
        }));
  return OptionUtils$SmartcutsMacros.andThen((function (index) {
                var match = Belt_List.get(commandLog, index);
                if (match === undefined) {
                  return ;
                }
                var match$1 = match.command;
                var commandId = match.id;
                if (typeof match$1 === "number") {
                  return ;
                }
                switch (match$1.TAG | 0) {
                  case /* CopyLinkAddressCommand */25 :
                      if (match$1._0.href === text) {
                        return commandId;
                      } else {
                        return ;
                      }
                  case /* CopyCommand */24 :
                  case /* CutCommand */26 :
                      break;
                  default:
                    return ;
                }
                var match$2 = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(match$1._0.selection);
                if (match$2[1] === text) {
                  return commandId;
                }
                
              }), maybeIndexOfMatchingCommand);
}

function substituteStaticTextWithPossibleDataRefToLastCopyOrCut(currSemantic, currChosen, text, currIntentionChoices, priorCommands, wrapTextFromCommand) {
  var commandId = getCommandLogIdOfLastCopyOrCutCommand(text, priorCommands);
  var match;
  if (commandId !== undefined) {
    var nextChosen = Curry._1(wrapTextFromCommand, {
          TAG: /* TextFromCommand */2,
          _0: {
            commandId: commandId,
            commandInfo: null,
            text: text
          }
        });
    match = [
      [nextChosen],
      nextChosen
    ];
  } else {
    match = [
      [],
      currChosen
    ];
  }
  return [
          $$Array.concat({
                hd: match[0],
                tl: {
                  hd: currIntentionChoices,
                  tl: {
                    hd: [currSemantic],
                    tl: /* [] */0
                  }
                }
              }),
          match[1]
        ];
}

function maybeAdjustInnerTextConfigWithDataRefs(priorCommands, param) {
  var chosen = param.chosen;
  var match = Belt_Array.reduce(param.intentionChoices, [
        [],
        chosen,
        chosen
      ], (function (param, intention) {
          var preferredChosen = param[2];
          var nextChosen = param[1];
          var nextIntentionChoices = param[0];
          var match;
          var exit = 0;
          if (typeof intention === "number") {
            exit = 1;
          } else {
            switch (intention.TAG | 0) {
              case /* MatchesFullInnerText */0 :
                  var text = intention._0;
                  if (text.TAG === /* StaticText */0) {
                    match = substituteStaticTextWithPossibleDataRefToLastCopyOrCut(intention, nextChosen, text._0, nextIntentionChoices, priorCommands, (function (textFromCommand) {
                            return {
                                    TAG: /* MatchesFullInnerText */0,
                                    _0: textFromCommand
                                  };
                          }));
                  } else {
                    exit = 1;
                  }
                  break;
              case /* MatchesInnerTextPrefix */1 :
                  var text$1 = intention._0;
                  if (text$1.TAG === /* StaticText */0) {
                    match = substituteStaticTextWithPossibleDataRefToLastCopyOrCut(intention, nextChosen, text$1._0, nextIntentionChoices, priorCommands, (function (textFromCommand) {
                            return {
                                    TAG: /* MatchesInnerTextPrefix */1,
                                    _0: textFromCommand
                                  };
                          }));
                  } else {
                    exit = 1;
                  }
                  break;
              case /* ContainsInnerText */2 :
                  var text$2 = intention._0;
                  if (text$2.TAG === /* StaticText */0) {
                    match = substituteStaticTextWithPossibleDataRefToLastCopyOrCut(intention, nextChosen, text$2._0, nextIntentionChoices, priorCommands, (function (textFromCommand) {
                            return {
                                    TAG: /* ContainsInnerText */2,
                                    _0: textFromCommand
                                  };
                          }));
                  } else {
                    exit = 1;
                  }
                  break;
              default:
                exit = 1;
            }
          }
          if (exit === 1) {
            match = [
              $$Array.append(nextIntentionChoices, [intention]),
              nextChosen
            ];
          }
          var nextChosen2 = match[1];
          var preferredChosen2;
          var exit$1 = 0;
          var exit$2 = 0;
          var exit$3 = 0;
          if (typeof preferredChosen === "number" || !(preferredChosen.TAG === /* ContainsInnerText */2 && preferredChosen._0.TAG === /* TextFromCommand */2)) {
            exit$3 = 3;
          } else {
            preferredChosen2 = preferredChosen;
          }
          if (exit$3 === 3) {
            if (typeof nextChosen2 === "number" || !(nextChosen2.TAG === /* ContainsInnerText */2 && nextChosen2._0.TAG === /* TextFromCommand */2)) {
              exit$2 = 2;
            } else {
              preferredChosen2 = nextChosen2;
            }
          }
          if (exit$2 === 2) {
            if (typeof preferredChosen === "number" || !(preferredChosen.TAG === /* ContainsInnerText */2 && preferredChosen._0.TAG === /* StaticText */0)) {
              exit$1 = 1;
            } else {
              preferredChosen2 = preferredChosen;
            }
          }
          if (exit$1 === 1) {
            preferredChosen2 = nextChosen2;
          }
          return [
                  match[0],
                  nextChosen2,
                  preferredChosen2
                ];
        }));
  return {
          intentionChoices: match[0],
          chosen: match[2]
        };
}

var AuthoringConfig = {
  maybeAdjustInnerTextConfigWithDataRefs: maybeAdjustInnerTextConfigWithDataRefs
};

function maybeSubstituteUrlIntoDataRef$1(log, dataRef) {
  if (dataRef.TAG !== /* TextFromUrl */5) {
    return ;
  }
  var textFromUrlParam = dataRef._0;
  var match = Belt_List.get(log, textFromUrlParam.commandIndex);
  if (match !== undefined) {
    return {
            TAG: /* TextFromUrl */5,
            _0: {
              commandId: textFromUrlParam.commandId,
              commandIndex: textFromUrlParam.commandIndex,
              url: match.contextGlobal.url
            }
          };
  }
  
}

function maybeSubstituteUrlIntoPlaybackCommandWithContext(log, commandWithContext) {
  var command = commandWithContext.command;
  if (typeof command === "number") {
    return commandWithContext;
  }
  switch (command.TAG | 0) {
    case /* PasteInInputCommand */27 :
        var commandValue = command._0;
        var dataRef = commandValue.text;
        var newDataRef = maybeSubstituteUrlIntoDataRef$1(log, dataRef);
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* PasteInInputCommand */27,
                  _0: {
                    positioning: commandValue.positioning,
                    text: newDataRef !== undefined ? newDataRef : dataRef,
                    label: commandValue.label
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    case /* PasteInContentEditableCommand */28 :
        var commandValue$1 = command._0;
        var dataRef$1 = commandValue$1.text;
        var newDataRef$1 = maybeSubstituteUrlIntoDataRef$1(log, dataRef$1);
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* PasteInContentEditableCommand */28,
                  _0: {
                    positioning: commandValue$1.positioning,
                    text: newDataRef$1 !== undefined ? newDataRef$1 : dataRef$1
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    case /* GoogleSheetsCommand */33 :
        var commandValue$2 = command._0;
        var upsertRowParam = commandValue$2.update;
        if (upsertRowParam.TAG === /* UpsertRow */0) {
          var match = upsertRowParam._0;
          var rowLocation = match.rowLocation;
          return {
                  id: commandWithContext.id,
                  command: {
                    TAG: /* GoogleSheetsCommand */33,
                    _0: {
                      spreadsheetId: commandValue$2.spreadsheetId,
                      sheetName: commandValue$2.sheetName,
                      colNames: commandValue$2.colNames,
                      update: {
                        TAG: /* UpsertRow */0,
                        _0: {
                          rowLocation: {
                            keyColumnIndex: rowLocation.keyColumnIndex,
                            keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$1, rowLocation.keyColumnValue)
                          },
                          cellValues: Belt_Array.map(match.cellValues, (function (cellValue) {
                                  if (typeof cellValue === "number") {
                                    return cellValue;
                                  }
                                  if (cellValue.TAG !== /* Value */1) {
                                    return cellValue;
                                  }
                                  var dataRef = cellValue._0;
                                  var newDataRef = maybeSubstituteUrlIntoDataRef$1(log, dataRef);
                                  return {
                                          TAG: /* Value */1,
                                          _0: newDataRef !== undefined ? newDataRef : dataRef
                                        };
                                }))
                        }
                      }
                    }
                  },
                  contextGlobal: commandWithContext.contextGlobal
                };
        }
        var upsertRowParam$1 = upsertRowParam._0;
        var cellUpdate = upsertRowParam$1.cellUpdate;
        var rowLocation$1 = upsertRowParam$1.rowLocation;
        var tmp;
        if (typeof cellUpdate === "number" || cellUpdate.TAG !== /* Value */1) {
          tmp = cellUpdate;
        } else {
          var dataRef$2 = cellUpdate._0;
          var newDataRef$2 = maybeSubstituteUrlIntoDataRef$1(log, dataRef$2);
          tmp = {
            TAG: /* Value */1,
            _0: newDataRef$2 !== undefined ? newDataRef$2 : dataRef$2
          };
        }
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* GoogleSheetsCommand */33,
                  _0: {
                    spreadsheetId: commandValue$2.spreadsheetId,
                    sheetName: commandValue$2.sheetName,
                    colNames: commandValue$2.colNames,
                    update: {
                      TAG: /* UpdateCell */1,
                      _0: {
                        rowLocation: {
                          keyColumnIndex: rowLocation$1.keyColumnIndex,
                          keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$1, rowLocation$1.keyColumnValue)
                        },
                        updatedColIndex: upsertRowParam$1.updatedColIndex,
                        cellUpdate: tmp
                      }
                    }
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    default:
      return commandWithContext;
  }
}

function adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell$1(commandLog, spreadsheetId, sheetName, commandLogIndex, rowLocation) {
  var priorCommandsWithContext = Belt_Array.slice($$Array.of_list(commandLog), 0, commandLogIndex);
  var arg = Belt_Array.reverse(priorCommandsWithContext);
  var maybeMatchingUpsert = (function (param) {
        return ArrayUtils$SmartcutsMacros.shortcut(param, arg);
      })(function (param) {
        var command = param.command;
        var id = param.id;
        if (typeof command === "number") {
          return ;
        }
        if (command.TAG !== /* GoogleSheetsCommand */33) {
          return ;
        }
        var curr = command._0;
        var upsert = curr.update;
        if (upsert.TAG !== /* UpsertRow */0) {
          return ;
        }
        var upsert$1 = upsert._0;
        if (curr.spreadsheetId === spreadsheetId && curr.sheetName === sheetName && (Caml_obj.caml_equal(Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.RowLocation.maybeGetCommandIdPointedToByMaybePrimaryKeyRef, rowLocation), id) || Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.RowLocation.getPrimaryKeyText, upsert$1.rowLocation) === Curry._1(GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.RowLocation.getPrimaryKeyText, rowLocation))) {
          return [
                  id,
                  upsert$1
                ];
        }
        
      });
  var arg$1 = Belt_Option.map(maybeMatchingUpsert, (function (param) {
          return {
                  keyColumnIndex: rowLocation.keyColumnIndex,
                  keyColumnValue: {
                    TAG: /* Value */1,
                    _0: {
                      TAG: /* TextFromGSheetUpsertCommand */3,
                      _0: {
                        commandId: param[0],
                        text: Curry._1(GoogleSheetTypes$SmartcutsMacros.Cell.Value.stringGet, param[1].rowLocation.keyColumnValue)
                      }
                    }
                  }
                };
        }));
  return OptionUtils$SmartcutsMacros.withDefault(rowLocation, arg$1);
}

function adjustGoogleSheetCommandPrimaryLookups$1(commandLog, commandLogIndex, commandWithContext) {
  var command = commandWithContext.command;
  if (typeof command === "number") {
    return commandWithContext;
  }
  if (command.TAG !== /* GoogleSheetsCommand */33) {
    return commandWithContext;
  }
  var cmdVal = command._0;
  var update = cmdVal.update;
  var tmp;
  if (update.TAG === /* UpsertRow */0) {
    tmp = update;
  } else {
    var updateCell = update._0;
    tmp = {
      TAG: /* UpdateCell */1,
      _0: {
        rowLocation: adjustRowLocationToRefPriorCommandThatAddedPrimaryKeyCell$1(commandLog, cmdVal.spreadsheetId, cmdVal.sheetName, commandLogIndex, updateCell.rowLocation),
        updatedColIndex: updateCell.updatedColIndex,
        cellUpdate: updateCell.cellUpdate
      }
    };
  }
  return {
          id: commandWithContext.id,
          command: {
            TAG: /* GoogleSheetsCommand */33,
            _0: {
              spreadsheetId: cmdVal.spreadsheetId,
              sheetName: cmdVal.sheetName,
              colNames: cmdVal.colNames,
              update: tmp
            }
          },
          contextGlobal: commandWithContext.contextGlobal
        };
}

var Playback = {
  maybeSubstituteUrlIntoPlaybackCommandWithContext: maybeSubstituteUrlIntoPlaybackCommandWithContext,
  adjustGoogleSheetCommandPrimaryLookups: adjustGoogleSheetCommandPrimaryLookups$1
};

function maybeSubstituteUrlIntoDataRef$2(log, dataRef) {
  if (dataRef.TAG !== /* TextFromUrl */5) {
    return ;
  }
  var textFromUrlParam = dataRef._0;
  var match = Belt_List.get(log, textFromUrlParam.commandIndex);
  if (match !== undefined) {
    return {
            TAG: /* TextFromUrl */5,
            _0: {
              commandId: textFromUrlParam.commandId,
              commandIndex: textFromUrlParam.commandIndex,
              url: match.contextGlobal.url
            }
          };
  }
  
}

function maybeSubstituteUrlIntoPlaybackCommandWithContext$1(log, commandWithContext) {
  var command = commandWithContext.command;
  if (typeof command === "number") {
    return commandWithContext;
  }
  switch (command.TAG | 0) {
    case /* PasteInInputCommand */27 :
        var commandValue = command._0;
        var dataRef = commandValue.text;
        var newDataRef = maybeSubstituteUrlIntoDataRef$2(log, dataRef);
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* PasteInInputCommand */27,
                  _0: {
                    positioning: commandValue.positioning,
                    text: newDataRef !== undefined ? newDataRef : dataRef,
                    label: commandValue.label
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    case /* PasteInContentEditableCommand */28 :
        var commandValue$1 = command._0;
        var dataRef$1 = commandValue$1.text;
        var newDataRef$1 = maybeSubstituteUrlIntoDataRef$2(log, dataRef$1);
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* PasteInContentEditableCommand */28,
                  _0: {
                    positioning: commandValue$1.positioning,
                    text: newDataRef$1 !== undefined ? newDataRef$1 : dataRef$1
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    case /* GoogleSheetsCommand */33 :
        var commandValue$2 = command._0;
        var upsertRowParam = commandValue$2.update;
        if (upsertRowParam.TAG === /* UpsertRow */0) {
          var match = upsertRowParam._0;
          var rowLocation = match.rowLocation;
          return {
                  id: commandWithContext.id,
                  command: {
                    TAG: /* GoogleSheetsCommand */33,
                    _0: {
                      spreadsheetId: commandValue$2.spreadsheetId,
                      sheetName: commandValue$2.sheetName,
                      colNames: commandValue$2.colNames,
                      update: {
                        TAG: /* UpsertRow */0,
                        _0: {
                          rowLocation: {
                            keyColumnIndex: rowLocation.keyColumnIndex,
                            keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$2, rowLocation.keyColumnValue)
                          },
                          cellValues: Belt_Array.map(match.cellValues, (function (cellValue) {
                                  if (typeof cellValue === "number") {
                                    return cellValue;
                                  }
                                  if (cellValue.TAG !== /* Value */1) {
                                    return cellValue;
                                  }
                                  var dataRef = cellValue._0;
                                  var newDataRef = maybeSubstituteUrlIntoDataRef$2(log, dataRef);
                                  return {
                                          TAG: /* Value */1,
                                          _0: newDataRef !== undefined ? newDataRef : dataRef
                                        };
                                }))
                        }
                      }
                    }
                  },
                  contextGlobal: commandWithContext.contextGlobal
                };
        }
        var upsertRowParam$1 = upsertRowParam._0;
        var cellUpdate = upsertRowParam$1.cellUpdate;
        var rowLocation$1 = upsertRowParam$1.rowLocation;
        var tmp;
        if (typeof cellUpdate === "number" || cellUpdate.TAG !== /* Value */1) {
          tmp = cellUpdate;
        } else {
          var dataRef$2 = cellUpdate._0;
          var newDataRef$2 = maybeSubstituteUrlIntoDataRef$2(log, dataRef$2);
          tmp = {
            TAG: /* Value */1,
            _0: newDataRef$2 !== undefined ? newDataRef$2 : dataRef$2
          };
        }
        return {
                id: commandWithContext.id,
                command: {
                  TAG: /* GoogleSheetsCommand */33,
                  _0: {
                    spreadsheetId: commandValue$2.spreadsheetId,
                    sheetName: commandValue$2.sheetName,
                    colNames: commandValue$2.colNames,
                    update: {
                      TAG: /* UpdateCell */1,
                      _0: {
                        rowLocation: {
                          keyColumnIndex: rowLocation$1.keyColumnIndex,
                          keyColumnValue: maybeSubstituteUrlIntoGoogleSheetCellValue(log, maybeSubstituteUrlIntoDataRef$2, rowLocation$1.keyColumnValue)
                        },
                        updatedColIndex: upsertRowParam$1.updatedColIndex,
                        cellUpdate: tmp
                      }
                    }
                  }
                },
                contextGlobal: commandWithContext.contextGlobal
              };
    default:
      return commandWithContext;
  }
}

var PlaybackRuntime = {
  maybeSubstituteUrlIntoPlaybackCommandWithContext: maybeSubstituteUrlIntoPlaybackCommandWithContext$1
};

function getCommandLogIdOfLastCopyOrCutCommand$1(text, commandLog) {
  var maybeIndexOfMatchingCommand = OptionUtils$SmartcutsMacros.map(Belt_Array.getIndexBy(Belt_Array.reverse($$Array.of_list(commandLog)), (function (param) {
              var command = param.command;
              if (typeof command === "number") {
                return false;
              }
              switch (command.TAG | 0) {
                case /* CopyLinkAddressCommand */25 :
                    return command._0.href === text;
                case /* CopyCommand */24 :
                case /* CutCommand */26 :
                    break;
                default:
                  return false;
              }
              var match = Selection__StrictSelection$SmartcutsMacros.Generic.extractTexts(command._0);
              return match[1] === text;
            })), (function (reversedIndex) {
          return (List.length(commandLog) - 1 | 0) - reversedIndex | 0;
        }));
  return OptionUtils$SmartcutsMacros.andThen((function (index) {
                var match = Belt_List.get(commandLog, index);
                if (match !== undefined) {
                  return match.id;
                }
                
              }), maybeIndexOfMatchingCommand);
}

function maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, value) {
  if (typeof value === "number") {
    return value;
  }
  if (value.TAG !== /* Value */1) {
    return value;
  }
  var dataRef = value._0;
  var tmp;
  var exit = 0;
  switch (dataRef.TAG | 0) {
    case /* StaticText */0 :
    case /* PasteText */1 :
        exit = 1;
        break;
    default:
      tmp = dataRef;
  }
  if (exit === 1) {
    var text = dataRef._0;
    var commandId = getCommandLogIdOfLastCopyOrCutCommand$1(text, commandLog);
    tmp = commandId !== undefined ? ({
          TAG: /* TextFromCommand */2,
          _0: {
            commandId: commandId,
            commandInfo: null,
            text: text
          }
        }) : dataRef;
  }
  return {
          TAG: /* Value */1,
          _0: tmp
        };
}

function adjustPasteCommand(commandLog, commandWithContextLocal) {
  var command = commandWithContextLocal.command;
  if (typeof command === "number") {
    return commandWithContextLocal;
  }
  switch (command.TAG | 0) {
    case /* PasteInInputCommand */27 :
        var cmdVal = command._0;
        var dataRef = cmdVal.text;
        var tmp;
        var exit = 0;
        switch (dataRef.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              exit = 1;
              break;
          default:
            tmp = dataRef;
        }
        if (exit === 1) {
          var text = dataRef._0;
          var commandId = getCommandLogIdOfLastCopyOrCutCommand$1(text, commandLog);
          tmp = commandId !== undefined ? ({
                TAG: /* TextFromCommand */2,
                _0: {
                  commandId: commandId,
                  commandInfo: null,
                  text: text
                }
              }) : dataRef;
        }
        return {
                command: {
                  TAG: /* PasteInInputCommand */27,
                  _0: {
                    positioning: cmdVal.positioning,
                    text: tmp,
                    label: cmdVal.label
                  }
                },
                contextLocal: commandWithContextLocal.contextLocal
              };
    case /* PasteInContentEditableCommand */28 :
        var cmdVal$1 = command._0;
        var dataRef$1 = cmdVal$1.text;
        var tmp$1;
        var exit$1 = 0;
        switch (dataRef$1.TAG | 0) {
          case /* StaticText */0 :
          case /* PasteText */1 :
              exit$1 = 1;
              break;
          default:
            tmp$1 = dataRef$1;
        }
        if (exit$1 === 1) {
          var text$1 = dataRef$1._0;
          var commandId$1 = getCommandLogIdOfLastCopyOrCutCommand$1(text$1, commandLog);
          tmp$1 = commandId$1 !== undefined ? ({
                TAG: /* TextFromCommand */2,
                _0: {
                  commandId: commandId$1,
                  commandInfo: null,
                  text: text$1
                }
              }) : dataRef$1;
        }
        return {
                command: {
                  TAG: /* PasteInContentEditableCommand */28,
                  _0: {
                    positioning: cmdVal$1.positioning,
                    text: tmp$1
                  }
                },
                contextLocal: commandWithContextLocal.contextLocal
              };
    case /* GoogleSheetsCommand */33 :
        var cmdVal$2 = command._0;
        var sheetDiff = cmdVal$2.sheetDiff;
        var tmp$2;
        switch (sheetDiff.TAG | 0) {
          case /* UpdateCell */0 :
              var row = sheetDiff._1;
              var cellDiff = sheetDiff._0;
              var diff = cellDiff.diff;
              var nextDiff;
              switch (diff.TAG | 0) {
                case /* FromTo */0 :
                    var fromTo = diff._0;
                    nextDiff = {
                      TAG: /* FromTo */0,
                      _0: {
                        from: fromTo.from,
                        to_: maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, fromTo.to_)
                      }
                    };
                    break;
                case /* Added */1 :
                    nextDiff = {
                      TAG: /* Added */1,
                      _0: maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, diff._0)
                    };
                    break;
                case /* Removed */2 :
                    nextDiff = diff;
                    break;
                
              }
              tmp$2 = {
                TAG: /* UpdateCell */0,
                _0: {
                  rowIndex: cellDiff.rowIndex,
                  colIndex: cellDiff.colIndex,
                  diff: nextDiff
                },
                _1: {
                  rowIndex: row.rowIndex,
                  cells: Belt_Array.map(row.cells, (function (param) {
                          return maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, param);
                        }))
                }
              };
              break;
          case /* AppendRow */1 :
              var row$1 = sheetDiff._0;
              tmp$2 = {
                TAG: /* AppendRow */1,
                _0: {
                  rowIndex: row$1.rowIndex,
                  cells: Belt_Array.map(row$1.cells, (function (param) {
                          return maybeUpdateGSheetCellValueToReferenceLastCopyOrCutCommand(commandLog, param);
                        }))
                }
              };
              break;
          case /* DeleteRow */2 :
              tmp$2 = sheetDiff;
              break;
          
        }
        return {
                command: {
                  TAG: /* GoogleSheetsCommand */33,
                  _0: {
                    spreadsheetId: cmdVal$2.spreadsheetId,
                    sheetName: cmdVal$2.sheetName,
                    colNames: cmdVal$2.colNames,
                    sheetDiff: tmp$2
                  }
                },
                contextLocal: commandWithContextLocal.contextLocal
              };
    default:
      return commandWithContextLocal;
  }
}

var Authoring = {
  maybeSubstituteUrlIntoAuthoringCommandWithContext: maybeSubstituteUrlIntoAuthoringCommandWithContext,
  maybeConvertContextMenuCmdsToCopyImageSrcCmds: maybeConvertContextMenuCmdsToCopyImageSrcCmds,
  adjustGoogleSheetCommandPrimaryLookups: adjustGoogleSheetCommandPrimaryLookups
};

exports.Authoring = Authoring;
exports.AuthoringConfig = AuthoringConfig;
exports.Playback = Playback;
exports.PlaybackRuntime = PlaybackRuntime;
exports.adjustPasteCommand = adjustPasteCommand;
/* Selector-SmartcutsMacros Not a pure module */
